export const signupapi='https://tenner-goods.onrender.com/register'
export const loginapi='https://tenner-goods.onrender.com/login'
export const mazama='https://tenner-goods.onrender.com/mazma'
export const tenner='https://tenner-goods.onrender.com/tennergoods'
export const Cart='https://tenner-goods.onrender.com/cart'
export const search='https://tenner-goods.onrender.com/search'
export const productsAPI='https://tenner-goods.onrender.com/products'